module.exports = __webpack_public_path__ + "static/jenny-6f810aa71b89142c0a8e214b09a1c01d.jpg";